module.exports={
	"Hash": "cyberpunk",
	"Name": "Cyberpunk",
	"Version": "1.0.0",
	"Description": "Neon on deep violet: hot pink and cyan with a mono face; a high-key pink-and-cyan light variant.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#fbf0ff",
					"Dark": "#0d0221"
				},
				"Secondary": {
					"Light": "#f6e6ff",
					"Dark": "#190b33"
				},
				"Tertiary": {
					"Light": "#efd9ff",
					"Dark": "#1f1040"
				},
				"Panel": {
					"Light": "#ffffff",
					"Dark": "#130826"
				},
				"Hover": {
					"Light": "#f3e0ff",
					"Dark": "#251447"
				},
				"Selected": {
					"Light": "#f1ccea",
					"Dark": "#431a52"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#2a0a3a",
					"Dark": "#e6d6ff"
				},
				"Secondary": {
					"Light": "#5a2a6a",
					"Dark": "#c3b0ee"
				},
				"Muted": {
					"Light": "#7a4a8a",
					"Dark": "#9a86c8"
				},
				"Placeholder": {
					"Light": "#a070b0",
					"Dark": "#6e5b96"
				},
				"OnBrand": {
					"Light": "#ffffff",
					"Dark": "#0d0221"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#d6008f",
					"Dark": "#ff2a6d"
				},
				"PrimaryHover": {
					"Light": "#b00075",
					"Dark": "#ff5a8d"
				},
				"Accent": {
					"Light": "#00a3c4",
					"Dark": "#05d9e8"
				}
			},
			"Border": {
				"Light": "#ffb3e6",
				"Dark": "#3a1f6e"
			},
			"Status": {
				"Success": {
					"Light": "#00a86b",
					"Dark": "#3affa3"
				},
				"Warning": {
					"Light": "#c98a00",
					"Dark": "#f9f002"
				},
				"Error": {
					"Light": "#e0306f",
					"Dark": "#ff426f"
				},
				"Info": {
					"Light": "#00a3c4",
					"Dark": "#05d9e8"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#f6e6ff",
					"Dark": "#190b33"
				},
				"Thumb": {
					"Light": "#ffb3e6",
					"Dark": "#3a1f6e"
				},
				"Hover": {
					"Light": "#7a4a8a",
					"Dark": "#9a86c8"
				}
			},
			"Selection": {
				"Background": {
					"Light": "#ff2a6d",
					"Dark": "#ff2a6d"
				},
				"Text": {
					"Light": "#ffffff",
					"Dark": "#0d0221"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#d6008f",
					"Dark": "#ff2a6d"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(0,0,0,0.12)",
					"Dark": "rgba(0,0,0,0.40)"
				}
			}
		}
	},
	"Brand": {
		"Name": "Plansheet",
		"Tagline": "Everything, drafted."
	}
}
